import React, { useEffect, useState } from 'react';

import { ButtonUI, DatagridPremiumUi, DialogUI } from '../Interface';
import { dataGridPremiumColumns } from '../../utils/helper';
import dayjs from 'dayjs';
import { Box } from '@mui/material';
import { DocStatus } from '../../config/document';

const SourceDocTableDialog = (props) => {
  const { open, onClose, docName, data, sourceDatagridIdentifiers, setSelectedDocRows, setDocLineTableDialogOpen } =
    props;
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  useEffect(() => {
    setRowSelectionModel(data.rows.map((row) => row.docId));
  }, [data.rows, open]);

  const columns = dataGridPremiumColumns([
    {
      field: 'docNum',
      headerName: 'Bizonylatszám',
      type: 'string',
      filterable: false,
    },
    {
      field: 'reference',
      headerName: 'Hivatkozási szám',
      type: 'string',
      filterable: false,
    },
    {
      field: 'docDate',
      headerName: 'Teljesítés dátuma',
      type: 'date',
      filterable: false,
      valueGetter: (_data, row) => {
        return new Date(row.docDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.docDate).format('YYYY-MM-DD');
      },
    },
    {
      field: 'issueDate',
      headerName: 'Kiállítás dátuma',
      type: 'date',
      filterable: false,
      valueGetter: (_data, row) => {
        return new Date(row.issueDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.issueDate).format('YYYY-MM-DD');
      },
    },
    {
      field: 'dueDate',
      headerName: 'Határidő',
      type: 'date',
      filterable: false,
      valueGetter: (_data, row) => {
        return new Date(row.dueDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.dueDate).format('YYYY-MM-DD');
      },
    },
    {
      field: 'companyShortName',
      headerName: 'Rövid név',
      type: 'string',
      filterable: false,
      renderCell: (data) => {
        return data.row.company?.shortName;
      },
    },
    {
      field: 'netInDocCur',
      headerName: 'Nettó érték',
      type: 'number',
      filterable: false,
    },
    {
      field: 'currencyCode',
      headerName: 'Pénznem',
      type: 'string',
      filterable: false,
    },
    {
      field: 'projectId',
      headerName: 'Projekt',
      type: 'string',
      filterable: false,
      renderCell: (data) => {
        return data.row.project?.projectName;
      },
    },
    {
      field: 'costCenterCode',
      headerName: 'Költséghely',
      type: 'string',
      filterable: false,
    },
    {
      field: 'deliveryMethodId',
      headerName: 'Szállítási mód',
      type: 'string',
      filterable: false,
      renderCell: (data) => {
        return data.row.deliveryMethod?.name;
      },
    },
    {
      field: 'shippingAdressId',
      headerName: 'Szállítási cím',
      type: 'string',
      filterable: false,
      renderCell: (data) => {
        return data.row.shippingAdress?.name;
      },
    },
  ]);

  const handleSelectRows = () => {
    const selectedRows = data.rows.filter((row) => rowSelectionModel.includes(row.docId));

    const docLine = selectedRows.flatMap((row) =>
      (row.docLine || [])
        .filter((line) => line.lineStatus === DocStatus.OPENED)
        .map((line) => ({
          ...line,
          reference: row.reference,
          docNum: row.docNum,
          currencyCode: row.currencyCode,
          baseDocnum: row.docNum,
          baseId: row.docId,
          baseDocType: row.docTypeId,
        }))
    );

    const firstDoc = selectedRows.reduce((min, r) => (r.docId < min.docId ? r : min), selectedRows[0]);

    const reference = [...new Set(selectedRows.map((r) => r.reference))].join('; ');

    const noteList = selectedRows.map((r) => {
      return `${r.docNum}`;
    });
    const note = `Forrása: ${docName} ${noteList.join(', ')}`;

    setSelectedDocRows({
      ...firstDoc,
      reference,
      note,
      docLine,
    });
    setDocLineTableDialogOpen(true);
    onClose();
  };

  return (
    <DialogUI open={open} onClose={onClose} headerContent={docName} maxWidth="xl" fullWidth>
      <DatagridPremiumUi
        datagridIdentifier={sourceDatagridIdentifiers.sourceDoc}
        datagridInitialState={{ density: 'compact' }}
        rows={data.rows}
        hideFooter
        height={700}
        columns={columns}
        headerFilters={false}
        getRowId={(row) => row.docId}
        paginationAndfilterMode="client"
        checkboxSelection
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={(newModel) => setRowSelectionModel(newModel)}
      />

      <Box display="flex" justifyContent="center" gap="0.5rem" mt="1rem">
        <ButtonUI
          text="Kiválasztás"
          className="bg-success"
          onClick={handleSelectRows}
          disabled={rowSelectionModel?.length === 0}
        />
        <ButtonUI text="Mégsem" className="bg-primary" onClick={onClose} />
      </Box>
    </DialogUI>
  );
};

export default SourceDocTableDialog;
